const PALLET_COLORS = [
  { id: 1, name: "SE", hex: "#8e44ad", text: "#ffffff" },
  { id: 2, name: "ELIT", hex: "#ffffff", text: "#131718" },
  { id: 3, name: "I. FOK", hex: "#7ec8f2", text: "#131718" },
  { id: 4, name: "II. FOK", hex: "#d35400", text: "#ffffff" },
  { id: 5, name: "CSÁVÁZATLAN", hex: "#2e9e44", text: "#ffffff" },
  { id: 6, name: "ALKALMATLAN", hex: "#e02424", text: "#ffffff" },
];

const COLOR_FILTER_NONE = 0;

function getPalletColor(id) {
  return PALLET_COLORS.find((color) => color.id === id);
}

export { PALLET_COLORS, COLOR_FILTER_NONE, getPalletColor };
